import AccountRemovalWebSocketSubscriber from './account-removal.websocket.subscriber'
import SlideOptionWebSocketSubscriber from './slide-option.websocket.subscriber'
import SlideWebSocketSubscriber from './slide.websocket.subscriber'
import PresentationWebSocketSubscriber from './presentation.websocket.subscriber'
import QuizWebSocketSubscriber from './quiz.websocket.subscriber'
import QuestionWebSocketSubscriber from './qna.websocket.subscriber'
import OpenTokWebSocketSubscriber from './opentok.websocket.subscriber'
import BrainStormWebSocketSubscriber from './brainstorm.websocket.subscriber'

export const messageSubscribers = {
  ...AccountRemovalWebSocketSubscriber,
  ...SlideOptionWebSocketSubscriber,
  ...SlideWebSocketSubscriber,
  ...QuizWebSocketSubscriber,
  ...PresentationWebSocketSubscriber,
  ...QuestionWebSocketSubscriber,
  ...OpenTokWebSocketSubscriber,
  ...BrainStormWebSocketSubscriber,
}

export const getMessageSubscriber = (type) => {
  return messageSubscribers[type]
}
